import styled from "styled-components/macro";
import { Accordion } from "@gcs/design-system/react";
import { DefaultTitleSmallFactory } from "../../Habitacional/core/Typograph/Typograph.Style";

export const AccordionBodyOverride = styled.div`
    width: 100%;
    padding: 20px 0;
    line-height: 150%;

    p + p {
      margim-bottom: 16px;
    }
`;

const AccordionItemStyled = styled(Accordion.Item)(({ theme }) => ({
  borderBottomColor: theme.color.neutral["08"],
  borderBottomWidth: ".05em",
  "[class^=Accordionstyle__Head]": {
    color: theme.color.brandPrimary.light,
    "&:hover, &[open]": {
      color: theme.color.brandPrimary.dark,
    },
  },
  "[class^=Accordionstyle__Title]": {
    display: "block",
    width: "100%",
    height: "100%",
    paddingRight: "30px",
    position: "relative",
    color: "inherit",
  },
  "[class^=Accordionstyle__Body]:after": {
    height: "0px",
  },
}));

export const Divider = styled.div(() => ({
  width: '100%',
  height: 1,
  background: "#D1DBE3",
}))

export const AccordionTitle = styled.h4(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme })
}))

export const AccordionStyled = styled(Accordion)(() => ({}));

AccordionStyled.Item = AccordionItemStyled;
AccordionStyled.ItemBody = AccordionBodyOverride;